export default __webpack_public_path__ + "static/media/apple_logo.fcb49e96.png";